import { ZodError, ZodSchema } from 'zod'

import * as Errors from '@/shared/lib/errors'
import { NotPromise } from '@/shared/types/NotPromise'

import { useLocalValidation } from './store'

/**
 * Get search validation enabled value
 * Used for enable/disable validation in search request
 *
 * @author Ivan Shchedrovskyi
 */
export const getAdminValidationActive = () => {
	return useLocalValidation.getState().isValidationEnabled
}

type GetValidatedData = <A, T>(
	/*
	 * Data for check on valid
	 */
	data: NotPromise<A>,
	/**
	 * Schema for check data on valid
	 */
	schema: ZodSchema<T>,

	/**
	 * Name of data for recognize it on error
	 */
	name: string
) => Promise<T>

export const validateServerData: GetValidatedData = async <A, T>(
	data: NotPromise<A>,
	schema: ZodSchema<T>,
	name: string
): Promise<T> => {
	if (getAdminValidationActive()) {
		try {
			return await schema.parseAsync(data)
		} catch (err) {
			if (err instanceof ZodError) {
				throw new Errors.ServerValidationError(name, err.message, data)
			}

			throw err
		}
	}

	return data as T
}
